import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import type { IReview } from '../home.interface';

/* single review without image - For reviews page */
export const Review2 = t0 => {
  const $ = _c(13);
  const {
    name,
    text,
    occupation
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="relative z-[10]"><Image src="/images/icons/ic_inverted_comma.svg" className="absolute left-0 top-0 w-8" alt="Inverted Comma" width={32} height={32} /><Image src="/images/icons/ic_inverted_comma.svg" className="absolute left-[2rem] top-0 w-8" alt="Inverted Comma" width={32} height={32} /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== text) {
    t2 = <div className="">{t1}<div className="relative z-20 ml-3 p-1 text-[17px] font-normal text-[#555659]">{text}</div></div>;
    $[1] = text;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== name) {
    t3 = <div className="text-lg font-medium text-[#3D3E40]">{name}</div>;
    $[3] = name;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== occupation) {
    t4 = <div className="text-lg text-[#555659]">{occupation}</div>;
    $[5] = occupation;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className="relative z-20 ml-3 mt-auto pt-4">{t3}{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t5) {
    t6 = <div className="flex flex-col rounded-2xl bg-[#F7FCFF] bg-origin-padding px-5 py-10 md:w-[47%] lg:w-[27%]">{t2}{t5}</div>;
    $[10] = t2;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};